module.exports = __webpack_public_path__ + "img/step-5.a7f3410d.jpg";